<template>
    <div id="index">
        <div class="page flex-col" v-show="!isMobile">
          <div class="SwiperBox">
            <!-- 图片 -->
            <img :class="['imgCss',ShowImg===index?'ShowCss':'']"
                 :src="item.imgUrl" v-for="(item,index) in imgList"/>
            <!-- 文字 -->
            <div class="p_info" :class="['titCss', ShowImg===index ?'ShowTitCss':isFirst?'':'titCss1']" v-for="(item,index) in imgList" :key="index">
                <h2 class="p_btitle">{{ item.title }}</h2>
                <div class="box_66 flex-col" :class="index === 0?'box_66_0': index === 1?'box_66_1':'box_66_2'"></div>
                <h6 class="p_subtitle" :style="{'letter-spacing':index === 1?'8.5px':''}" v-html="item.desc"></h6>
            </div>
            <!-- 左箭头按钮 -->
<!--            <div class="leftBtn" @click="throttle(PrevFun)">&larr;</div>-->
            <!-- 右箭头按钮 -->
<!--            <div class="rightBtn" @click="throttle(NextFun)">&rarr;</div>-->
            <!-- 下方指示点容器 -->
            <div class="instBox">
              <div v-for="(item,index) in imgList.length" :key="index"
                   @click="ShowImg=index" :class="['inst',ShowImg==index?'instActv':'']">
              </div>

            </div>
          </div>
            <div class="box_3 flex-col">
                <div class="box_4 flex-row">
                    <div class="group_5 flex-col">
                        <span class="text_12">公司介绍</span>
                        <img class="image_4" referrerpolicy="no-referrer" src="../../assets/client/dx_1.jpg" />
                        <div class="text-wrapper_1" v-html="content"></div>
                        <div class="section_3 flex-row justify-between">
                            <span class="text_16" @click="toLink('/Client/AboutSailHero/index')">查看更多</span>
                            <img class="thumbnail_3" referrerpolicy="no-referrer" src="../../assets/client/icon_fh1.png" />
                        </div>
                    </div>
                    <!-- <div class="group_6 flex-col">
                         <div class="group_7 flex-col"></div>
                    </div> -->
                    <div class="text-wrapper_6_be">
                        <transition  name="slide">
                            <div class="text-wrapper_2 flex-col" v-if="telshow">
                                <span class="text_17">4001-300-137</span>
                            </div>
                        </transition>
                    </div>
                    <div class="box_8_1">
                        <div class="group_8 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                            <div class="image-text_1 flex-col justify-between">
                                <img class="label_1" referrerpolicy="no-referrer" src="../../assets/client/tel.png" />
                                <span class="text-group_1">业务咨询</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box_5 flex-col">
                    <div class="block_3 flex-row justify-between">
                        <span class="text_18">新闻中心</span>
                        <div class="group_9 flex-row justify-between">
                            <div class="text-wrapper_3 flex-col" @mouseenter="setState('NT01')" :style="{'background-color':modelitem=='NT01'?'rgba(0, 90, 214, 1)':'white'}">
                                <span class="text_19"  :style="{'color':modelitem=='NT01'?'white':'rgba(0, 90, 214, 1)'}">公司动态</span>
                            </div>
                            <div class="text-wrapper_4 flex-col" @mouseenter="setState('NT02')" :style="{'background-color':modelitem=='NT02'?'rgba(0, 90, 214, 1)':'white'}">
                                <span class="text_20"  :style="{'color':modelitem=='NT02'?'white':'rgba(0, 90, 214, 1)'}">媒体关注</span>
                            </div>
                            <div class="text-wrapper_5 flex-col" @mouseenter="setState('NT03')" :style="{'background-color':modelitem=='NT03'?'rgba(0, 90, 214, 1)':'white'}">
                                <span class="text_21"  :style="{'color':modelitem=='NT03'?'white':'rgba(0, 90, 214, 1)'}">行业新闻</span>
                            </div>
                            <div class="text-wrapper_6 flex-col" @mouseenter="setState('NT04')" :style="{'background-color':modelitem=='NT04'?'rgba(0, 90, 214, 1)':'white'}">
                                <span class="text_22"  :style="{'color':modelitem=='NT04'?'white':'rgba(0, 90, 214, 1)'}">影像先河</span>
                            </div>
                        </div>
                    </div>
                    <div class="image-wrapper_1 flex-row">
                        <img class="image_5" referrerpolicy="no-referrer" src="../../assets/client/dx_1.jpg" />
                    </div>
                    <div class="block_4 flex-row justify-between">
                        <div>
                            <div class="block_5 flex-col hoverInfo_1"  :title=NewsHeadlines.title @click="selelctNews(NewsHeadlines)">
                                <div class="group_10 flex-col">
                                    <img :src="`${NewsHeadlines.ViewFilePath}`"> </img>
                                    <div class="text-wrapper_7 flex-col">
                                        <span class="text_23">{{NewsHeadlines.publishdate}}</span>
                                    </div>
                                </div>
                                <span class="text_24" :title=NewsHeadlines.title>{{NewsHeadlines.title}}</span>
                                <div class="group_11 flex-col"></div>
                                <span class="paragraph_5">{{NewsHeadlines.subtitle}}</span>
                        </div>
                        <div class="group_12 flex-row justify-between" @click="toNewsMore(NewsHeadlines)">
                            <span class="text_25">MORE&nbsp;>></span>
                        </div>
                        </div>
                        <div class="block_6 flex-col">
                            <div>
                                <div class="group_13 flex-row justify-between" :title="NewsTop1.title" @click="selelctNews(NewsTop1)">
                                    <div class="group_14 flex-col">
                                        <img  :src="`${NewsTop1.ViewFilePath}`" style="  background-size:contain;"></img>
                                        <div class="text-wrapper_8 flex-col">
                                            <span class="text_26">{{NewsTop1.publishdate}}</span>
                                        </div>
                                    </div>
                                    <div class="group_15 flex-col">
                                        <span class="text_27">{{NewsTop1.title}}</span>
                                        <span class="paragraph_6" >{{NewsTop1.subtitle}}</span>
                                    </div>

                                </div>
                                <div class="section_4 flex-row justify-between" @click="toNewsMore(NewsTop1)">
                                    <span class="text_28">MORE&nbsp;>></span>
                                </div>
                            </div>
                            <template v-for="(item,index) in NewslistOther">
                                <div class="group_16 flex-row justify-between" :title="item.title" @click="selelctNews(item)">
                                    <div class="text-wrapper_9 flex-col">
                                        <span class="text_29">{{item.publishdate.substring(5,10)}}</span>
                                        <span class="text_30">{{item.publishdate.substring(0,4)}}</span>
                                    </div>
                                    <div class="section_5 flex-col justify-between">
                                        <div class="box_6 flex-col"></div>
                                    </div>
                                    <div class="section_6 flex-col">
                                        <span class="text_35">{{item.title}}</span>
                                        <div class="text-group_2 flex-col justify-between">
                                            <span class="paragraph_7">{{item.subtitle}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </div>
                </div>
                <div class="box_9 flex-col">
                    <div class="text-wrapper_10 flex-row">
                        <span class="text_38">业务中心</span>
                    </div>
                    <div class="image-wrapper_2 flex-row">
                        <img class="image_6"
                             referrerpolicy="no-referrer"
                             src="../../assets/client/dx_1.jpg" />
                    </div>
                    <div class="block_11 flex-row justify-between">
                        <div class="accordion">
                            <ul>
                                <li class="item1 active" @mouseenter="yunMouse(0)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-0 flex-col"></div>
                                        <span class="text-group_10-0">蓝天云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==0">
                                        <div class="section_6-0 flex-col"></div>
                                        <span class="text-group_10-0">蓝天云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type1.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type1" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="item2" @mouseenter="yunMouse(1)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-1 flex-col"></div>
                                        <span class="text-group_10-1">碧水云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==1">
                                        <div class="section_6-1 flex-col"></div>
                                        <span class="text-group_10-1">碧水云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type2.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type2" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="item3" @mouseenter="yunMouse(2)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-2 flex-col"></div>
                                        <span class="text-group_10-2">净土云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==2">
                                        <div class="section_6-2 flex-col"></div>
                                        <span class="text-group_10-2">净土云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type3.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type3" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="item4" @mouseenter="yunMouse(3)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-3 flex-col"></div>
                                        <span class="text-group_10-3">低碳云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==3">
                                        <div class="section_6-3 flex-col"></div>
                                        <span class="text-group_10-3">低碳云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type4.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type4" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="item5" @mouseenter="yunMouse(4)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-4 flex-col"></div>
                                        <span class="text-group_10-4">自然云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==4">
                                        <div class="section_6-4 flex-col"></div>
                                        <span class="text-group_10-4">自然云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type5.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type5" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="item6" @mouseenter="yunMouse(5)">
                                    <a href="javascript:void(0)">
                                        <div class="section_6-5 flex-col"></div>
                                        <span class="text-group_10-5">健康云</span>
                                    </a>
                                    <div class="flex-col" v-if="yunIndex==5">
                                        <div class="section_6-5 flex-col"></div>
                                        <span class="text-group_10-5">健康云</span>
                                        <div class="text-wrapper_22_1 flex-col" v-if="cloudData.type6.length>0">
                                            <el-scrollbar style="overflow-x: hidden">
                                                <div class="text-wrapper_22_2 flex-col">
                                                    <span class="text_58_2" v-for="(item,index) in cloudData.type6" @click="toLink('/Client/CloudInfo?id='+item.id)" :title="item.system_name">{{item.system_name}}</span>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="box_15 flex-col">
                    <div class="text-wrapper_20 flex-row">
                        <span class="text_53">产品展示</span>
                    </div>
                    <div class="image-wrapper_3 flex-row">
                        <img class="image_8" referrerpolicy="no-referrer" src="../../assets/client/dx_1.jpg" />
                    </div>
                    <div class="box_16 flex-row justify-between">
                        <img class="label_2" referrerpolicy="no-referrer" src="../../assets/client/an_1.png" @click="getBusinessNext(-1)" />
                        <div class="list_1 flex-row">
                            <div class="list-items_1-0 flex-col" @click="toProduct(ProductIndex)" @mouseenter="getBusinessInfo(ProductIndex,'left')" @mouseleave="ProductMouseleave(ProductIndex)" :style="{border:ProductInfo.id === getProduct(ProductIndex).id?'1px solid rgba(13, 139, 255, 1)':''}">
                                <img :src="`${FileAddress+getProduct(ProductIndex).FilePath.replace(' ', '%20').replace(/\\/g, '/')}`"></img>
                            </div>
                            <div class="list-items_1-1 flex-col" @click="toProduct(ProductIndex+1)" @mouseenter="getBusinessInfo(ProductIndex+1,'center')" :style="{ border:ProductInfo.id === getProduct(ProductIndex + 1).id?'1px solid rgba(13, 139, 255, 1)':'' }">
                                <img :src="`${FileAddress+getProduct(ProductIndex + 1).FilePath.replace(' ', '%20').replace(/\\/g, '/')}`"></img>
                            </div>
                            <div class="list-items_1-2 flex-col" @click="toProduct(ProductIndex+2)" @mouseenter="getBusinessInfo(ProductIndex+2,'right')" :style="{ border:ProductInfo.id === getProduct(ProductIndex + 2).id?'1px solid rgba(13, 139, 255, 1)':'' }">
                                <img :src="`${FileAddress+getProduct(ProductIndex + 2).FilePath.replace(' ', '%20').replace(/\\/g, '/')}`"></img>
                            </div>
                        </div>
                        <img class="label_3" referrerpolicy="no-referrer" src="../../assets/client/an_2.png" @click="getBusinessNext(1)" />
                    </div>
                    <div class="box_17 flex-row">
                        <div class="block_8 flex-col">
                            <transition name="fade">
                                <div class="image-text_6 flex-row justify-between" v-if="pShow">
                                    <div class="group_23 flex-col"></div>
                                    <span class="text-group_8" @click="toLink('/Client/Business/Product?tpid='+ProductInfo.parent_id3+'&tid='+ProductInfo.parent_id+'&id='+ProductInfo.id)">{{ProductInfo.business_name}}</span>
                                </div>
                            </transition>
                            <transition name="fade">
                                <span class="text_54" v-if="pShow">产品简介</span>
                            </transition>
                            <transition name="fade">
                                <span class="paragraph_14" v-if="pShow" v-html="ProductInfo.business_desc"></span>
                            </transition>
                        </div>
                        <div class="nav nav-border" :class="navclass"></div>
                        <div class="nav nav-background" :class="navclass"></div>
                    </div>

                </div>
                <div class="box_18 flex-col">
                    <div class="text-wrapper_21 flex-row">
                        <span class="text_55">分子公司</span>
                    </div>
                    <div class="image-wrapper_4 flex-row">
                        <img class="image_9" referrerpolicy="no-referrer" src="../../assets/client/dx_1.jpg" />
                    </div>
                    <div class="box_19 flex-row">
                        <div class="box_23 flex-row" v-for="(item,index) in Member">
                            <div class="image-text_14 flex-col justify-between">
                                <div style="height: 3.6vw; overflow: hidden;">
                                    <img class="box_24 flex-col" referrerpolicy="no-referrer" :src="FileAddress+item.FilePath" @load="resizeImage" />
                                </div>
                                <span class="text-group_16">{{item.full_name}}</span>
                            </div>
                            <div class="box_25 flex-col">
                                <span class="paragraph_15" v-html="item.company_desc.replace(/<[^>]*>/g, '')"></span>
                                <div class="group_25 flex-row justify-between">
                                    <span class="text_58" @click="toLink('/Client/MemberInfo?id='+item.id)">查看更多</span>
                                    <img class="thumbnail_6" referrerpolicy="no-referrer" src="../../assets/client/icon_fh3.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box_26">
                        <div class="footer-container">
                            <!-- 第一行：三个标题 -->
                            <div class="footer-row footer-titles">
                                <div class="footer-column">
                                    <h3 class="footer-title">投资者关系</h3>
                                </div>
                                <div class="footer-column">
                                    <h3 class="footer-title">人力资源</h3>
                                </div>
                                <div class="footer-column">
                                    <h3 class="footer-title">联系我们</h3>
                                </div>
                            </div>
                            
                            <!-- 第二行：详细内容 -->
                            <div class="footer-row footer-content">
                                <!-- 投资者关系列 -->
                                <div class="footer-column">
                                    <div class="footer-links">
                                        <span class="footer-link" @click="toLink('/Client/InvestorRelations?modelitem=IT04')">股票信息</span>
                                        <span class="footer-link" @click="toLink('/Client/InvestorRelations?modelitem=IT01')">公告信息</span>
                                        <span class="footer-link" @click="toLink('/Client/InvestorRelations?modelitem=IT02')">投资者教育</span>
                                        <a class="footer-link" href="https://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300137&orgId=9900014612" target="_blank">投资者服务</a>
                                    </div>
                                </div>
                                
                                <!-- 人力资源列 -->
                                <div class="footer-column">
                                    <div class="footer-links">
                                        <span class="footer-link" @click="toLink('/Client/AboutSailHero/index?hr=1')">梦想家园</span>
                                        <span class="footer-text">"来先河，创未来"<br/>先河环保2021招聘梦想家园</span>
                                    </div>
                                </div>
                                
                                <!-- 联系我们列 -->
                                <div class="footer-column">
                                    <div class="footer-links">
                                        <span class="footer-text">地址：河北省石家庄市高新区湘江道251号</span>
                                        <span class="footer-text">客服电话：4001-300-137</span>
                                        <span class="footer-text">邮箱：corp@sailhero.com.cn&nbsp;&nbsp;&nbsp;&nbsp;sales@sailhero.com.cn</span>
                                        <span class="footer-text">官方微信众公号：sailhero</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div class="box_29 box flex-row" @click="toLink('/Client/Business/Product?tpid=da6dcf8f-5ed2-41be-8b0c-7c1985236add&tid=&id=')">-->
<!--                    <span class="text_70">智慧监测</span>-->
<!--                    <div class="group_26 flex-col">-->
<!--                        <img referrerpolicy="no-referrer" src="../../assets/client/t_1.png"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="box_30 box flex-row" @click="toLink('/Client/Business/Product?tpid=06646146-47a0-46a8-a62d-496794ece100&tid=&id=')">-->
<!--                    <div class="image-text_15 flex-row justify-between">-->
<!--                        <span class="text-group_17">大数据分析及服务</span>-->
<!--                        <div class="group_27 flex-col">-->
<!--                            <img referrerpolicy="no-referrer" src="../../assets/client/t_2.png"/>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="box_31 box flex-row" @click="toLink('/Client/Business/Product?tpid=ca20251b-d4fe-4ab3-9d7e-9fce1f1bcb15&tid=&id=')">-->
<!--                    <span class="text_71">治理修复</span>-->
<!--                    <div class="box_32 flex-col">-->
<!--                        <img referrerpolicy="no-referrer" src="../../assets/client/t_3.png"/>-->
<!--                    </div>-->
<!--                </div>-->
              <div class="list_1_new flex-row">
                <div class="list-items_1-0_new box flex-row" @click="toLink('/Client/Business/Product?tpid=da6dcf8f-5ed2-41be-8b0c-7c1985236add&tid=&id=')">
                  <span class="text_12-0">智慧监测</span>
                  <img
                      class="image_3-0"
                      referrerpolicy="no-referrer"
                      src="../../assets/client/icon_zhjc.png"
                  />
                </div>
                <div class="list-items_1-1_new box flex-row"  @click="toLink('/Client/Business/Product?tpid=06646146-47a0-46a8-a62d-496794ece100&tid=&id=')">
                  <span class="text_12-1">大数据分析及服务</span>
                  <img
                      class="image_3-1"
                      referrerpolicy="no-referrer"
                      src="../../assets/client/icon_dsjfxjfw.png"
                  />
                </div>
                <div class="list-items_1-2_new box flex-row"  @click="toLink('/Client/Business/Product?tpid=ca20251b-d4fe-4ab3-9d7e-9fce1f1bcb15&tid=&id=')">
                  <span class="text_12-2">治理修复</span>
                  <img
                      class="image_2-2"
                      referrerpolicy="no-referrer"
                      src="../../assets/client/icon_zlxf.png"
                  />
                </div>
              </div>
            </div>
        </div>
        <div class="mobile-index" v-show="isMobile">
          <div class="mobile-carousel mobile-section">
            <div class="mobile-carousel__viewport">
              <div
                v-for="(item, index) in imgList"
                :key="item.imgUrl"
                :class="['mobile-carousel__item', { 'is-active': ShowImg === index }]"
              >
                <img class="mobile-carousel__image" :src="item.imgUrl" :alt="item.title" />
                <div class="mobile-carousel__mask"></div>
                <div class="mobile-carousel__caption">
                  <div class="mobile-carousel__title">{{ item.title }}</div>
                  <div class="mobile-carousel__desc" v-html="item.desc"></div>
                </div>
              </div>
            </div>
            <div class="mobile-carousel__indicators">
              <span
                v-for="(item, index) in imgList"
                :key="'indicator-' + index"
                :class="['mobile-carousel__dot', { 'is-active': ShowImg === index }]"
                @click="ShowImg = index"
              ></span>
            </div>
          </div>

          <!-- 三个业务入口按钮 -->
          <section class="mobile-section mobile-quick-links">
            <div 
              class="mobile-quick-links__card"
              @click="toLink('/Client/Business/Product?tpid=da6dcf8f-5ed2-41be-8b0c-7c1985236add&tid=&id=')"
            >
              <span class="mobile-quick-links__title">智慧监测</span>
              <img 
                class="mobile-quick-links__icon" 
                src="../../assets/client/icon_zhjc.png" 
                alt="智慧监测"
              />
            </div>
            <div 
              class="mobile-quick-links__card"
              @click="toLink('/Client/Business/Product?tpid=06646146-47a0-46a8-a62d-496794ece100&tid=&id=')"
            >
              <span class="mobile-quick-links__title">大数据分析及服务</span>
              <img 
                class="mobile-quick-links__icon" 
                src="../../assets/client/icon_dsjfxjfw.png" 
                alt="大数据分析及服务"
              />
            </div>
            <div 
              class="mobile-quick-links__card"
              @click="toLink('/Client/Business/Product?tpid=ca20251b-d4fe-4ab3-9d7e-9fce1f1bcb15&tid=&id=')"
            >
              <span class="mobile-quick-links__title">治理修复</span>
              <img 
                class="mobile-quick-links__icon" 
                src="../../assets/client/icon_zlxf.png" 
                alt="治理修复"
              />
            </div>
          </section>

          <div class="mobile-container">
            <section class="mobile-section mobile-company">
              <header class="mobile-section__header">
                <h2 class="mobile-section__title">公司介绍</h2>
                <span class="mobile-section__action" @click="toLink('/Client/AboutSailHero/index')">查看更多</span>
              </header>
              <div class="mobile-company__content" v-html="content"></div>
              <div class="mobile-company__image">
                <img src="../../assets/client/bj.jpg" alt="公司介绍" />
              </div>
            </section>

            <section class="mobile-section mobile-news">
              <header class="mobile-section__header">
                <h2 class="mobile-section__title">新闻中心</h2>
                <span class="mobile-section__action" @click="toNewsMore(NewsHeadlines)">更多新闻</span>
              </header>
              <div class="mobile-news__categories">
                <button
                  v-for="tab in newsTabs"
                  :key="tab.value"
                  :class="['mobile-news__category', { 'is-active': modelitem === tab.value }]"
                  @click="setState(tab.value)"
                  type="button"
                >
                  {{ tab.label }}
                </button>
              </div>
              <div class="mobile-news__headline" v-if="NewsHeadlines.id">
                <div class="mobile-news__headline-card" @click="selelctNews(NewsHeadlines)">
                  <img class="mobile-news__headline-image" :src="NewsHeadlines.ViewFilePath" :alt="NewsHeadlines.title" />
                  <div class="mobile-news__headline-body">
                    <div class="mobile-news__date">{{ NewsHeadlines.publishdate }}</div>
                    <div class="mobile-news__title">{{ NewsHeadlines.title }}</div>
                    <div class="mobile-news__subtitle">{{ NewsHeadlines.subtitle }}</div>
                  </div>
                </div>
              </div>
              <div class="mobile-news__list">
                <article
                  v-if="NewsTop1.id"
                  class="mobile-news__item"
                  @click="selelctNews(NewsTop1)"
                >
                  <div class="mobile-news__item-meta">
                    <div class="mobile-news__item-day">{{ NewsTop1.publishdate.substring(5, 10) }}</div>
                    <div class="mobile-news__item-year">{{ NewsTop1.publishdate.substring(0, 4) }}</div>
                  </div>
                  <div class="mobile-news__item-content">
                    <div class="mobile-news__item-title">{{ NewsTop1.title }}</div>
                    <div class="mobile-news__item-subtitle">{{ NewsTop1.subtitle }}</div>
                  </div>
                </article>
                <article
                  v-for="item in NewslistOther"
                  :key="item.id"
                  class="mobile-news__item"
                  @click="selelctNews(item)"
                >
                  <div class="mobile-news__item-meta">
                    <div class="mobile-news__item-day">{{ item.publishdate.substring(5, 10) }}</div>
                    <div class="mobile-news__item-year">{{ item.publishdate.substring(0, 4) }}</div>
                  </div>
                  <div class="mobile-news__item-content">
                    <div class="mobile-news__item-title">{{ item.title }}</div>
                    <div class="mobile-news__item-subtitle">{{ item.subtitle }}</div>
                  </div>
                </article>
              </div>
            </section>

            <section class="mobile-section mobile-solutions">
              <header class="mobile-section__header">
                <h2 class="mobile-section__title">业务中心</h2>
                <span class="mobile-section__action" @click="toLink('/Client/Business/Product?tpid=da6dcf8f-5ed2-41be-8b0c-7c1985236add&tid=&id=')">更多</span>
              </header>
              <div class="mobile-solutions__grid">
                <div
                  v-for="(tab, index) in cloudTabs"
                  :key="tab.value"
                  :class="['mobile-solutions__card', { 'is-active': yunIndex === index }]"
                  @click="yunMouse(index)"
                >
                  <div class="mobile-solutions__icon-wrapper">
                    <img :src="require(`@/assets/client/0${index + 1}.png`)" :alt="tab.label" class="mobile-solutions__icon" />
                  </div>
                  <div class="mobile-solutions__label">{{ tab.label }}</div>
                </div>
              </div>
              <div class="mobile-solutions__content" v-if="currentCloudList.length > 0">
                <div class="mobile-solutions__list" :style="{ '--arrow-left': arrowLeftPosition }">
                  <div
                    v-for="item in currentCloudList"
                    :key="item.id"
                    class="mobile-solutions__item"
                    @click="toLink('/Client/CloudInfo?id=' + item.id)"
                  >
                    <span class="mobile-solutions__item-text">{{ item.system_name }}</span>
                    <span class="mobile-solutions__item-arrow">→</span>
                  </div>
                </div>
              </div>
            </section>

              <section class="mobile-section mobile-products" v-if="Product && Product.length">
                <header class="mobile-section__header">
                  <h2 class="mobile-section__title">产品展示</h2>
                </header>
                <div class="mobile-products__carousel">
                  <div class="mobile-products__frame" v-if="MobileProduct">
                    <img
                      v-if="MobileProduct.FilePath"
                      class="mobile-products__image"
                      :src="FileAddress + MobileProduct.FilePath.replace(' ', '%20').replace(/\\/g, '/')"
                      :alt="MobileProduct.business_name"
                    />
                    <div class="mobile-products__name">{{ MobileProduct.business_name }}</div>
                    <div class="mobile-products__desc" v-html="MobileProduct.business_desc"></div>
                  </div>
                  <div class="mobile-products__controls">
                    <button class="mobile-products__button" type="button" @click="switchMobileProduct(-1)">‹</button>
                    <div class="mobile-products__dots">
                      <span
                        v-for="(item, index) in Product"
                        :key="item.id + '-dot'"
                        :class="['mobile-products__dot', { 'is-active': mobileProductIndex === index }]"
                      ></span>
                    </div>
                    <button class="mobile-products__button" type="button" @click="switchMobileProduct(1)">›</button>
                  </div>
                </div>
              </section>

              <section class="mobile-section mobile-members" v-if="Member && Member.length">
                <header class="mobile-section__header">
                  <h2 class="mobile-section__title">分子公司</h2>
                </header>
                <div class="mobile-members__grid">
                  <article
                    v-for="member in Member"
                    :key="member.id"
                    class="mobile-members__card"
                    @click="toLink('/Client/MemberInfo?id=' + member.id)"
                  >
                    <div class="mobile-members__logo-wrapper">
                      <img
                        class="mobile-members__logo"
                        :src="FileAddress + member.FilePath"
                        :alt="member.full_name"
                      />
                    </div>
                    <div class="mobile-members__info">
                      <h3 class="mobile-members__name">{{ member.full_name }}</h3>
                      <p class="mobile-members__desc" v-html="member.company_desc.replace(/<[^>]*>/g, '')"></p>
                    </div>
                    <div class="mobile-members__arrow">›</div>
                  </article>
                </div>
              </section>
            </div>
          </div>
    </div>
</template>
<script>
    import "../../assets/client/index.css";
    import "../../assets/client/index-mobile.css";
    export default {
        data() {
            return {
              imgList: [
                {imgUrl: require("@/assets/img/banner1.jpg"), title:"生态环境全产业链综合服务商", desc:"以监测为基础，以数据链应用为核心，打造智慧高效的生态环境</br>数字化治理体系，支撑美丽中国建设，推动生态环境保护高质量发展"},
                {imgUrl: require("@/assets/img/banner2.jpg"), title:"深耕监测治理 双轮驱动前行", desc:"生态网格化监测系统的开发者与创新者</br>工业有机废气第三方治理模式的践行者"},
                {imgUrl: require("@/assets/img/banner3.jpg"), title:"生态环境/低碳", desc:"智慧监测&nbsp;&nbsp;&nbsp;&nbsp;治理修复&nbsp;&nbsp;&nbsp;&nbsp;大数据分析及服务"},
              ],
              isFirst:true, // 是否首次进入
              ShowImg:0,  // 表示当前显示的图片
              flag:true, // 用来节流防止重复点击
              start:null, // 自动执行下一张定时器
                FileAddress: process.env.VUE_APP_FileAddress.replace('fileapi/', ''),
                content: "",
                Member: [],
                telshow:false,
                Product: [{}, {}, {}],
                ProductInfo: { id: "", parent_id: "", parent_id3:"",business_name: "", business_desc: "" },
                ProductIndex:0,
                modelitem:"NT01",
                NewsHeadlines:{},
                NewsTop1:{},
                NewslistOther:[],
                navclass:'nav_1',
                cloudData: { type1: [], type2: [], type3: [], type4: [], type5: [], type6: [] },
                cloudInfo: [],
                cloudPageIndex: 1,
                cloudbuttontype: {
                    uppage: 'true',
                    downpage: 'true'
                },
                pShow: true,//产品动画
                yunIndex: 0,
                isMobile: false,
                mobileProductIndex: 0,
            }
        },
        computed: {
            currentCloudList() {
                const key = `type${this.yunIndex + 1}`;
                return this.cloudData[key] || [];
            },
            MobileProduct() {
                return this.Product[this.mobileProductIndex] || {};
            },
            newsTabs() {
                return [
                    { label: "公司动态", value: "NT01" },
                    { label: "媒体关注", value: "NT02" },
                    { label: "行业新闻", value: "NT03" },
                    { label: "影像先河", value: "NT04" },
                ];
            },
            cloudTabs() {
                return [
                    { label: "蓝天云", value: "type1" },
                    { label: "碧水云", value: "type2" },
                    { label: "净土云", value: "type3" },
                    { label: "低碳云", value: "type4" },
                    { label: "自然云", value: "type5" },
                    { label: "健康云", value: "type6" },
                ];
            },
            arrowLeftPosition() {
                // 箭头位置计算说明:
                // grid padding: 16px 20px (按钮在grid内,左右各20px padding)
                // content padding: 0 20px 20px (list在content内,左右各20px padding)
                // grid和content的左边距都是20px,所以箭头left=0时对应grid内容区域的起始位置
                
                const gap = 8; // 按钮间隙
                const screenWidth = window.innerWidth;
                const gridPadding = 20;
                
                // grid内容区域宽度 = 屏幕宽度 - 左右padding
                const gridContentWidth = screenWidth - (gridPadding * 2);
                
                // 6个按钮,5个gap
                const totalGapWidth = gap * 5;
                
                // 单个按钮宽度
                const buttonWidth = (gridContentWidth - totalGapWidth) / 6;
                
                // 第n个按钮的中心位置
                // 使用缩放因子来调整箭头移动距离
                const moveScale = 0.92; // 调整这个值(0.9-1.0)来控制箭头移动距离,值越小移动距离越短
                const buttonCenter = this.yunIndex * ((buttonWidth + gap) * moveScale) + (buttonWidth / 2);
                
                // 箭头位置 = 按钮中心 - 箭头宽度一半
                // 如果箭头偏右,减小arrowOffset;如果偏左,增大arrowOffset
                const arrowOffset = 15; // 可以调整这个值来微调箭头位置
                const arrowLeft = buttonCenter - arrowOffset;
                
                return `${Math.max(0, arrowLeft)}px`;
            }
        },
        methods: {
            handleResize() {
                this.isMobile = window.innerWidth <= 768;
            },
            getCompanyProfileData() {
                let that = this;
                that.$api.post("/Client/getCompanyProfile", {},
                    function (res) {
                        if (res.code === "200") {
                            that.content = res.data.about_content;
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            getMemberData() {
                let that = this;
                that.$api.post("/Client/getMamberData", { pageSize: -1, pageIndex: -1, sort: "" },
                    function (res) {
                        that.Member = [];
                        if (res.code === "200") {
                            that.Member = res.data;
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            resizeImage(event) {
                const img = event.target;
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                img.style.width = `${width}px`;
                img.style.height = `${height}px`;
            },
            toLink(path) {
                this.$router.push(path);
            },
            getBusinessData() {
                let that = this;
                that.ProductInfo = { id: "", parent_id: "", parent_id3:"",business_name: "", business_desc: "" };
                that.Product = [{ FilePath: "", business_name: "", business_desc: "" }, { FilePath: "", business_name: "", business_desc: "" }, { FilePath: "", business_name: "", business_desc: "" }];
                that.$api.post("/Client/getBusinessData", {
                    treePath: "",
                    level: 4,
                    businessType: "产品中心",
                    pageSize: -1,
                    pageIndex: -1,
                    pId: "",
                    isShowIndex:1
                },
                    function (res) {
                        if (res.code === "200") {
                            that.Product = res.data;
                            that.ProductInfo = res.data[0];
                            that.mobileProductIndex = 0;
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            getBusinessNext(n) {
                if (n == -1 && this.ProductIndex>0) {
                    this.ProductIndex += n;
                } else if (n == 1 && this.ProductIndex < this.Product.length-3) {
                    this.ProductIndex += n;
                }
                this.ProductInfo = this.Product[this.ProductIndex];
                $('.nav').addClass('nav_1').removeClass('nav_2').removeClass('nav_3')
            },
            getBusinessInfo(n, item) {
                this.pShow = false;
                this.ProductInfo = this.Product[n];

                if(item=='left'){  this.navclass = "nav_1";}
                if(item=='center'){ this.navclass = "nav_2";  }
                if (item == 'right') { this.navclass = "nav_3"; }

                let that = this;
                setTimeout(function () { that.pShow = true; },100);
            },
            setState(state){
                let that = this;
                that.modelitem = state;
                that.getNewsCenterlist();
            },
            getNewsHeadlines() {
                let that = this;
                that.$api.post("/Client/getNewsHeadlines", {},
                    function (res) {
                        if (res.code === "200") {
                            that.NewsHeadlines={
                                id:res.data.id,
                                newsmodel:res.data.news_model,
                                modelitem:res.data.model_item,
                                title:res.data.news_title,
                                subtitle:res.data.news_subtitle,
                                is_open_attachment:res.data.is_open_attachment,
                                url:res.data.url,
                                is_open_url:res.data.is_open_url,
                                publishdate:res.data.publishdate.replace(/-/g,'/'),
                                ViewFilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data.ViewFilePath.replace(" ", "%20").replace(/\\/g, '/'),
                                FilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data.FilePath.replace(" ", "%20").replace(/\\/g, '/')
                            }
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            getNewsCenterlist() {
                let that = this;
                that.$api.post("/Client/getNewsCenterlist", {
                    pageSize:4,
                    pageIndex:1,
                    newsmodel:'NewsType',
                    modelitem:that.modelitem,
                    isdelshowindex:'1',
                    ismain:'1'
                },
                function (res) {
                    if (res.code === "200") {
                        that.NewsTop1={};
                        that.NewslistOther=[];
                        for(let i=0;i<res.data.length;i++)
                        {
                            if(i==0){
                                that.NewsTop1={
                                    id:res.data[i].id,
                                    title:res.data[i].news_title,
                                    newsmodel:res.data[i].news_model,
                                    modelitem:res.data[i].model_item,
                                    subtitle:res.data[i].news_subtitle,
                                    isopenattachment:res.data[i].is_open_attachment,
                                    publishdate:res.data[i].publishdate.replace(/-/g,'/').substring(0,10),
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    ViewFilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/'),
                                    FilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')
                                }
                            }else{
                                that.NewslistOther.push({
                                    id:res.data[i].id,
                                    title:res.data[i].news_title,
                                    newsmodel:res.data[i].news_model,
                                    modelitem:res.data[i].model_item,
                                    subtitle:res.data[i].news_subtitle,
                                    isopenattachment:res.data[i].is_open_attachment,
                                    publishdate:res.data[i].publishdate.replace(/-/g,'/').substring(0,10),
                                    url:res.data[i].url,
                                    is_open_url:res.data[i].is_open_url,
                                    ViewFilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data[i].ViewFilePath.replace(" ", "%20").replace(/\\/g, '/'),
                                    FilePath:process.env.VUE_APP_FileAddress.replace('fileapi/', '')+res.data[i].FilePath.replace(" ", "%20").replace(/\\/g, '/')
                                });
                            }
                        }
                    }
                },
                function (res) {
                    //that.$message.error("服务器异常，删除出错");
                }
                );
            },
            selelctNews(item){
              var _this = this;
              if(item.is_open_attachment=='1'){
                 window.open(item.FilePath, '_blank');
              }else if(item.is_open_url=='1')
              {
                window.open(item.url, '_blank');
              }
              else{
                _this.$router.push({
                    path: "/Client/NewsDetails",
                    query: {
                    id:item.id,
                    modelitem:item.modelitem,
                    newsmodel:item.newsmodel
                },
              });
              }
          },
            toNewsMore(item){
                let that = this;
                that.$router.push({
                    path: "/Client/NewsTrends",
                    name: "ClientNewsTrends",
                    params: {
                        modelitem: item.modelitem,
                        newsmodel: item.newsmodel
                    },
                });
            },
            getHomeCloudData() {
                let that = this;
                that.$api.post("/Client/getHomeCloudData", {
                    pageSize: -1,
                    pageIndex: -1,
                    cloud_type: null
                },
                    function (res) {
                        if (res.code === "200") {
                            that.cloudData = { type1: [], type2: [], type3: [], type4: [], type5: [], type6: [] };
                            res.data.forEach(element => {
                                that.cloudData["type" + element.cloud_type].push({
                                    id: element.id,
                                    system_name: element.system_name,
                                    system_content: element.system_content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/[\s\n]/g, "")
                                })
                            });
                        }
                    },
                    function (res) {
                        //that.$message.error("服务器异常，删除出错");
                    }
                );
            },
            handleMouseEnter(){
                let that = this;
                that.telshow = true;
            },
            handleMouseLeave(){
                let that = this;
                that.telshow = false;
            },
            getProduct(index) {
                if (this.Product.length <= index) {
                    return { FilePath:"",id:""};
                } else {
                    return this.Product[index];
                }
            },
            toProduct(ProductIndex) {
                var data = this.getProduct(ProductIndex);
                if (data.id != "") {
                    this.toLink('/Client/Business/Product?tpid=' + data.parent_id3 + '&tid=' + data.parent_id + '&id=' + data.id);
                }
            },
            yunMouse(n) {
                this.yunIndex = n;
            },
            ProductMouseleave(ProductIndex) {
                if (ProductIndex === 0) { this.paragraph_14_0 = "paragraph_14_0"; }

            },
            switchMobileProduct(step) {
                if (!this.Product.length) return;
                const next = this.mobileProductIndex + step;
                if (next < 0) {
                    this.mobileProductIndex = this.Product.length - 1;
                } else if (next >= this.Product.length) {
                    this.mobileProductIndex = 0;
                } else {
                    this.mobileProductIndex = next;
                }
                this.ProductInfo = this.Product[this.mobileProductIndex] || {};
            },
          // 这里定义一个鼠标移入移出事件，鼠标悬停时停止自动轮播，鼠标移出则重新执行自动轮播
          MouseFun(type){// 停止定时器            // 重新执行定时器
            type=='移入'?clearTimeout(this.start):this.setTimeoFun()
          },
          setTimeoFun(){
            this.start = setInterval(()=>{
              this.NextFun()
            },4000)
          },
          // 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
          throttle(fun) {
            if (this.flag) {
              this.flag = false;
              fun(); // 此为模板中传递进来的PrevFun()或NextFun()函数
              setTimeout(() => {
                this.flag = true;
              }, 1200); // 节流间隔时间
            }
          },
          // 上一张
          PrevFun(){
            if(this.ShowImg!==0){
              this.ShowImg--
            }else{
              this.ShowImg=this.imgList.length-1
            }
          },
          // 下一张
          NextFun(){
            if(this.ShowImg!==this.imgList.length-1){
              this.ShowImg++;
            }else{
              this.ShowImg=0
            }
          },
        },
        mounted() {
            let that = this;
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
            that.setTimeoFun();
            that.getCompanyProfileData();
            that.getBusinessData();
            that.getMemberData();
            that.getNewsHeadlines();
            that.getNewsCenterlist();
            that.getHomeCloudData();

            $(document).ready(function () { $(".accordion").accordion(); });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            $.fn.accordion = function (opts) {
                var defaults = { max: "25.53vw", min: "9.17vw", speed: "1000" }
                var opts = $.extend(defaults, opts);
                this.each(function () {
                    var t = $(this), m = t.children(), c = m.children();
                    //触发事件
                    m.find(".active a").hide();
                    m.on("mouseenter", "li", function () {
                        $(this).find("a").parent().siblings().find("a").show();

                        $(this).addClass('active')
                            .animate({ width: opts.max }, opts.speed)
                            .find("a")//.fadeOut()
                            .parent().siblings().removeClass('active')
                            .animate({ width: opts.min }, opts.speed);

                        $(this).find("a").hide();
                    });
                })
            }
        },
        watch: {}
    }
</script>
<style scoped>
    /* 定义产品动画 */
    .fade-enter-active, .fade-leave-active {
        transition: transform 0.5s;
    }
    .fade-enter, .fade-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(12vw);
    }

    ::v-deep .text-wrapper_22_1 .el-scrollbar__wrap {
        overflow-x: hidden;
        overflow-y: auto;
    }
    /* 纵向滚动条的滑块 */
    ::v-deep .text-wrapper_22_1 .el-scrollbar__bar.is-vertical .el-scrollbar__thumb {
        border-radius: 1px;
        background-color: gray;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    }

    /* 图片容器样式 */
    .SwiperBox {
      height: 100vh;
      max-height: 1440px;
      width: 1920px;
      min-width: 1920px;
      overflow: hidden;
      position: relative;
      border: 1px solid #ccc;
      box-sizing: border-box;
    }
    /* 图片默认样式 */
    .imgCss {
      position: absolute;
      left: 0px;
      top: 0px;
      height: 100%;
      width: 100%;
      object-fit: cover;
      animation: bannerimg 2s;
      opacity: 0;
      transition: 2s;  /* 淡入淡出过渡时间 */
    }
    .titCss{
      opacity: 0;
      transition: 1s;  /* 淡入淡出过渡时间 */
    }
    .titCss1{
      animation: puBanner_down 1.5s;
      opacity: 0;
    }
    /* 图片选中样式(继承上方默认样式) */
    .ShowCss {
      opacity: 1;
    }
    .ShowTitCss {
      opacity: 1;
      animation: puBanner 1.5s;
    }
    /* 两个按钮共有的样式,也可直接使用箭头图片替代 */
    .leftBtn,
    .rightBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(109, 109, 109, 0.445);
      color: #fff;
      border-radius: 50%;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
    }
    .leftBtn {
      left: 10px;
    }
    .rightBtn {
      right: 10px;
    }
    /* 下方指示器盒子 */
    .instBox{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 30px;
      display: flex;
    }
    /* 小圆点 */
    .inst{
      width: 10px;
      height: 10px;
      border: 1px solid #ccc;
      margin-right: 8px;
      background: #fff;
      border-radius: 50%;
      cursor: pointer;
    }
    .inst:last-child{
      margin-right: 0px;
    }
    .instActv{
      border: 1px solid #0055A6;
      background: #0055A6;
    }

    .p_btitle {
      color: rgba(1, 82, 110, 1);
       font-size: 50px;
       font-weight: 600;
       letter-spacing: 2.5px;
      font-family: Helvetica-Bold;
       -webkit-user-select: none;
       -moz-user-select: none;
       -ms-user-select: none;
       user-select: none;
     }
    .box_66 {
      background-color: rgba(45, 82, 108, 0.5);
      opacity: 0.5;
      width: 700px;
      height: 2px;
      position: relative;
      bottom: 30px;
    }
    .box_66_0{
      width: 957px;
      opacity: 0.5;
    }
    .box_66_1{
      width: 645px;
      opacity: 0.5;
    }
    .box_66_2{
      width: 595px;
      opacity: 0.5;
    }
    .p_subtitle {
      color: rgba(0, 96, 128, 1);
      font-size: 30px;
      font-family: Helvetica-Bold;
      font-weight: 500;
      position: relative;
      bottom: 80px;
      letter-spacing:2px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .p_info {
      color: red;
      width: 100%;
      max-width: 1600px;
      padding: 0 5px;
      position: absolute;
      left: 257px;
      top: 170px;
    }

    @keyframes puBanner {
      from {
        transform: translateY(200px);
        opacity: 0
      }

      to {
        transform: translateY(0);
        opacity: 1
      }
    }

    @keyframes puBanner_down {
      from {
        transform: translateY(0);
        opacity: 1
      }

      to {
        transform: translateY(200px);
        opacity: 0
      }
    }

    @keyframes bannerimg {
      from {
        transform: scale(1.2)
      }

      to {
        transform: scale(1);
      }
    }


    .list_1_new {
      width: 1400px;
      height: 110px;
      justify-content: space-between;
      position: absolute;
      left: 260px;
      top: 720px;
    }
    .list-items_1-0_new {
      width: 452px;
      height: 110px;
      margin-right: 22px;
      background: rgba(255,255,255,0.7);
      border-radius: 2px;
      backdrop-filter: blur(12px);
      cursor: pointer;
    }
    .text_12-0 {
      width: 176px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(30, 30, 30, 1);
      font-size: 22px;
      font-family: PingFangSC-Regular;
      font-weight: normal;
      text-align: left;
      white-space: nowrap;
      line-height: 22px;
      margin: 44px 0 0 48px;
    }
    .image_3-0 {
      width: 55px;
      height: 55px;
      margin: 34px 24px 0 120px;
    }
    .list-items_1-1_new {
      width: 452px;
      height: 110px;
      margin-right: 22px;
      background: rgba(255,255,255,0.7);
      border-radius: 2px;
      backdrop-filter: blur(12px);
      cursor: pointer;
    }
    .text_12-1 {
      width: 176px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(30, 30, 30, 1);
      font-size: 22px;
      font-family: PingFangSC-Regular;
      font-weight: normal;
      text-align: left;
      white-space: nowrap;
      line-height: 22px;
      margin: 44px 0 0 48px;
    }
    .image_3-1 {
      width: 52px;
      height: 52px;
      margin: 28px 28px 0 120px;
    }
    .list-items_1-2_new {
      width: 452px;
      height: 110px;
      margin-right: 22px;
      background: rgba(255,255,255,0.7);
      border-radius: 2px;
      backdrop-filter: blur(12px);
      cursor: pointer;
    }
    .text_12-2 {
      width: 176px;
      height: 22px;
      overflow-wrap: break-word;
      color: rgba(30, 30, 30, 1);
      font-size: 22px;
      font-family: PingFangSC-Regular;
      font-weight: normal;
      text-align: left;
      white-space: nowrap;
      line-height: 22px;
      margin: 44px 0 0 48px;
    }
    .image_2-2 {
      width: 52px;
      height: 52px;
      margin: 28px 24px 0 120px;
    }

    /* PC端Footer响应式样式 */
    @media (min-width: 769px) {
        #index .page {
            display: block;
            width: 100vw;
            min-height: auto;
            overflow-x: hidden;
        }
        
        #index .box_3 {
            width: 100vw;
            min-height: auto;
        }

        /* 确保footer区域在页面底部正确显示，无空白间隙 */
        #index .box_26 {
            width: 100vw !important;
            margin-left: 0 !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            position: relative;
            left: 0;
        }

        /* 确保分子公司区域正确包含浮动元素 */
        #index .box_19::after {
            content: "";
            display: table;
            clear: both;
        }
    }

    /* 确保footer内容在不同屏幕尺寸下都能正确显示 */
    @media (min-width: 1200px) and (max-width: 1600px) {
        .box_26 {
            min-height: 250px;
        }
    }

    @media (min-width: 1601px) {
        .box_26 {
            min-height: 300px;
        }
    }
</style>

